/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Trash2 } from 'lucide-react';
import { sendRequest } from '../../../api/shootAPI';
import API from '../../../api/endpoints';
import { UserContext } from '../../../contexts/User';
import { NotificationContext } from '../../../contexts/Notification';
import ConfirmDialog from '../../../components/ConfirmDialog';

function DesignationDeleteModal({ closeModal, getData, designation }) {
  const { activeWorkspace } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const [deleting, setDeleting] = useState(false);

  const handleDeleteRequest = async () => {
    setDeleting(true);
    const { success } = await sendRequest({
      method: 'delete',
      url: API.WORKSPACE.deleteDesignation(activeWorkspace.id, designation.id),
    });
    setDeleting(false);
    closeModal();
    if (success) {
      displayNotification({ message: 'Designation has been deleted successfully.', severity: 'success' });
      getData();
    } else {
      displayNotification({ message: 'There was an issue deleting designation.', severity: 'error' });
    }
  };

  return (
    <ConfirmDialog
      tone="danger"
      icon={<Trash2 size={24} />}
      title="Delete this designation?"
      description={`You're about to delete the "${designation.name}" designation. This action cannot be undone.`}
      confirmLabel="Delete"
      cancelLabel="Cancel"
      confirming={deleting}
      onConfirm={handleDeleteRequest}
      onCancel={closeModal}
    />
  );
}

DesignationDeleteModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  getData: PropTypes.func.isRequired,
  designation: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default DesignationDeleteModal;
